// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"SectionTitle_sectionTitle__3Ajbe","border":"SectionTitle_border__3g2Pe","title":"SectionTitle_title__2GwM0"};